import React from 'react';
import { TextField } from '@material-ui/core';
import './TextInput.scss';

const TextInput = ({
    label, value, onChange, error, placeholder, className, rows = 1, inputProps, multiline, size = "md",
}) => {
    return (
        <div className={className}>
            <div className='label'>{label}</div>
            <TextField
                className={`textfield ${size}`}
                error={error}
                value={value}
                defaultValue={placeholder || ""}
                variant="outlined"
                rows={rows}
                onChange={onChange}
                multiline={multiline}
                inputProps={inputProps}
            />
        </div>
    )
}

export default TextInput;